import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { createQueryKeys } from '@lukemorales/query-key-factory'
import { RequestTypes } from './requestTypes'

export const documentEngineTemplatesKeys = createQueryKeys(
  'document-engine-templates',
  {
    byOrganisation: ({
      organisationId,
    }: RequestTypes['getDocumentEngineTemplates']) => {
      return {
        queryKey: [organisationId],
        queryFn: async () => {
          const { data } = await APIAxiosInstance.get(
            `document-engine/${organisationId}/templates`,
          )
          return data
        },
      }
    },
  },
)
